// 회사 목록 테이블

import React from "react";

const CompanyList = ({
  companies,
  editData,
  editCompanyId,
  setEditData,
  onOpenFactoryModal,
  onEdit,
  onView,
}) => {
  const onChangeEdit = (key) => (e) =>
    setEditData((prev) => ({ ...prev, [key]: e.target.value }));

  return (
    <div className="overflow-x-auto py-4">
      <table className="min-w-full border border-gray-300 text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-2 py-1">역할</th>
            <th className="border px-2 py-1">회사명</th> 
            <th className="border px-2 py-1">주소</th>
            <th className="border px-2 py-1">전화번호</th>
            <th className="border px-2 py-1">이메일</th>
            <th className="border px-2 py-1">관리</th>
          </tr>
        </thead>
        <tbody>
          {companies.map((c) => (
            <tr
              key={c.id}
              className="hover:bg-gray-50 cursor-pointer"
              onClick={() => onView?.(c)} // 행 클릭 시 상세보기 열기
            >
              <td className="border px-2 py-1">{c.roles.join(', ')}</td> {/* 역할 */}
              <td className="border px-2 py-1">{c.name}</td>
              <td className="border px-2 py-1">
                {c.address}
                {c.detail_address ? `, ${c.detail_address}` : ""}{" "}
                {c.extra_address}
              </td>
              <td className="border px-2 py-1">{c.phone}</td>
              <td className="border px-2 py-1">{c.email}</td>
              <td className="border px-2 py-1">
                <div className="flex gap-2">
                  <button
                    onClick={(e) => {
                      e.stopPropagation(); // 행 클릭과 분리
                      onEdit?.(c, { editMode: true }); // 수정모드로 바로 열기
                    }}
                    className="bg-yellow-500 hover:bg-yellow-600 text-white px-2 py-1 rounded"
                  >
                    수정
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation(); // 행 클릭과 분리
                      onOpenFactoryModal(c);
                    }}
                    className="bg-indigo-600 hover:bg-indigo-700 text-white px-2 py-1 rounded"
                  >
                    공장 관리
                  </button>
                </div>
              </td>
            </tr>
          ))}
          {companies.length === 0 && (
            <tr>
              <td colSpan={11} className="text-center py-4 text-gray-500">
                검색 결과가 없습니다.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CompanyList;
